"use strict";

var _interopRequireWildcard = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _core = require("echarts/core");
var _vue = require("vue");
var _charts = require("echarts/charts");
var _components = require("echarts/components");
var _renderers = require("echarts/renderers");
var _vueEcharts = _interopRequireWildcard(require("vue-echarts"));
var _shop = require("@/api/shop.js");
var _vueApi = require("@/utils/vueApi.js");
var _default = {
  __name: 'huandian',
  props: ['merchant-id'],
  setup: function setup(__props) {
    var props = __props;
    (0, _core.use)([_components.TitleComponent, _components.TooltipComponent, _components.LegendComponent, _components.ToolboxComponent, _components.GridComponent, _components.MarkLineComponent, _charts.LineChart, _renderers.CanvasRenderer]);
    (0, _vue.provide)(_vueEcharts.THEME_KEY, 'light');
    (0, _vue.onMounted)(function () {
      console.log('onMounted', _charts.graphic);
      // totalNum.value = deviceInfo.reduce((sum, item) => sum + item.num, 0)
      init();
    });
    var init = function init() {
      getSwapData();
    };
    var merchantId = (0, _vue.computed)(function () {
      return props.merchantId;
    });
    var store = (0, _vueApi.useStore)();
    (0, _vue.watch)(function () {
      return store.state.triggerApiCall;
    }, function () {
      // Make API call in ChildComponent1
      console.log('store.state.triggerApiCall', store.state.triggerApiCall);
      getSwapData();
    });
    var batterySwapChartData = (0, _vue.ref)([]);
    var getSwapData = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var response;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _shop.getBatteryExchangeChartData)({
                  merchant_id: merchantId.value
                });
              case 3:
                response = _context.sent;
                console.log('getBatteryExchangeChartData', response);
                batterySwapChartData.value = response.batteryChartData;
                totalNum.value = response.exchange_count;
                chart2Option.value.xAxis.data = batterySwapChartData.value.length > 0 ? batterySwapChartData.value.map(function (item) {
                  return item.date;
                }) : [];
                chart2Option.value.series[0].data = batterySwapChartData.value.length > 0 ? batterySwapChartData.value.map(function (item) {
                  return item.num;
                }) : [];
                // handle the response here
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.error('Error in getDeviceInfo:', _context.t0);
                // handle the error here
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));
      return function getSwapData() {
        return _ref.apply(this, arguments);
      };
    }();
    var reset = function reset(params) {
      console.log('params', params);
    };
    // 换电总数据
    var totalNum = (0, _vue.ref)('-');
    // 近10日换电数据[{date:'',num:''}]

    var chart2Option = (0, _vue.ref)({
      title: {
        text: '实时换电数据'
      },
      tooltip: {
        trigger: 'axis',
        formatter: function formatter(params) {
          var html = params[0].name + '<br/>';
          for (var i = 0; i < params.length; i++) {
            var param = params[i];
            html += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + param.color + '"></span>';
            html += param.seriesName + ': ' + param.value + ' 次<br/>';
          }
          return html;
        }
      },
      legend: {
        data: ['换电数据']
      },
      toolbox: {
        show: false,
        feature: {
          dataZoom: {
            yAxisIndex: 'none'
          },
          dataView: {
            readOnly: false
          },
          magicType: {
            type: ['line', 'bar']
          },
          restore: {},
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: batterySwapChartData.value.length > 0 ? batterySwapChartData.map(function (item) {
          return item.date;
        }) : []
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value} 次'
        }
      },
      series: [{
        name: '换电数据',
        type: 'line',
        smooth: true,
        data: batterySwapChartData.value.length > 0 ? batterySwapChartData.map(function (item) {
          return item.num;
        }) : [],
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0,
              color: 'rgba(0, 102, 204, 0.3)'
            }, {
              offset: 1,
              color: 'rgba(0, 102, 204, 0)'
            }]
          }
        },
        markPoint: {
          data: [{
            type: 'max',
            name: 'Max',
            itemStyle: {
              color: '#546789'
            }
          }, {
            type: 'min',
            name: 'Min',
            itemStyle: {
              color: '#ff6f6f'
            }
          }]
        },
        markLine: {
          data: [{
            type: 'average',
            name: '平均值',
            label: {
              color: '#00b700',
              show: true,
              position: 'middle',
              formatter: function formatter(params) {
                return "".concat(params.name, ": ").concat(Math.round(params.value), " \u6B21");
              }
            },
            lineStyle: {
              color: '#00b700'
            }
          }]
        }
      }]
    });
    return {
      __sfc: true,
      init: init,
      props: props,
      merchantId: merchantId,
      store: store,
      batterySwapChartData: batterySwapChartData,
      getSwapData: getSwapData,
      reset: reset,
      totalNum: totalNum,
      chart2Option: chart2Option,
      VChart: _vueEcharts.default
    };
  }
};
exports.default = _default;